import {
  useGroup
} from "./2NIRKFVH.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  __objRest
} from "./PNRLI7OV.js";

// src/composite/composite-group.ts
var useCompositeGroup = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var CompositeGroup = createComponent(
  (props) => {
    const htmlProps = useCompositeGroup(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CompositeGroup.displayName = "CompositeGroup";
}

export {
  useCompositeGroup,
  CompositeGroup
};
